import type { PayerHistoryItem } from '@features/patient-coverages/types';
import dayjs from 'dayjs';

/** Preserve the backend's service-date order; never rank by amount or source date. */
export function payerHistorySummary(items: PayerHistoryItem[]): {
  item?: PayerHistoryItem;
  hasNewerUnusable: boolean;
} {
  const index = items.findIndex(
    item =>
      (item.lifecycle_status === 'reported' || item.lifecycle_status === 'corrected') &&
      item.reported_responsibility_cents != null &&
      Number.isFinite(item.reported_responsibility_cents) &&
      !!item.service_date_from &&
      dayjs(item.service_date_from).isValid(),
  );
  return { item: index < 0 ? undefined : items[index], hasNewerUnusable: index > 0 };
}
